module.exports = __webpack_public_path__ + "img/14.2f5b4021.png";